/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Google_Sign_InInputs */

const en_common_sign_google_sign_in = /** @type {(inputs: Common_Sign_Google_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with Google`)
};

/**
* | output |
* | --- |
* | "Sign in with Google" |
*
* @param {Common_Sign_Google_Sign_InInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_google_sign_in = /** @type {((inputs?: Common_Sign_Google_Sign_InInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Google_Sign_InInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_google_sign_in(inputs)
});
export { common_sign_google_sign_in as "common.sign.google_sign_in" }